import Quote from 'containers/Sections/Quote';

export default function QuoteComponent() {
    return Quote;
}
